import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { timeAgo } from '../../../shared/utils/date-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recent-videos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recent-videos.component.html',
  styleUrl: './recent-videos.component.scss'
})
export class RecentVideosComponent {
  private api = inject(ApiService);
  private router = inject(Router); 
  
  videos: any[] = [];
  // isLoading = false;

  ngOnInit() {
    this.loadRecentVideos();
  }

  loadRecentVideos() {
    // this.isLoading = true;
    this.api.get<any[]>('/videos').subscribe({
      next: (res) => {
        // Sort newest first and limit to 3
        this.videos = res
          .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
          .slice(0, 3)
          .map((v) => ({
            _id: v._id,
            application: v.project?.name || 'General',
            title: v.title,
            thumbnail: v.thumbnailUrl,
            videoUrl: v.url,
            viewed: timeAgo(v.createdAt),
            moduleSlug: this.slugify(v.project?.name || 'general'),
          }));

        // this.isLoading = false;
        console.log('🎥 Recent videos loaded:', this.videos);
      },
      error: (err) => {
        console.error(' Failed to load videos:', err);
        // this.isLoading = false;
      },
    });
  }

  slugify(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  // ✅ NEW — when a card is clicked
  openVideo(video: any) {
    // Example route: /content/estater-admin/video/691c1ed404935dedfd9d7349
    this.router.navigate(['/content', video.moduleSlug, 'video', video._id]);
  }
}
